import React from 'react'
import { useTranslation } from 'react-i18next'

import { categoryType, getIconByCategory } from 'appConfig/data'

const ALL_BUSINESS_FUNCTIONS = 'All Business Functions'

const AppSidebar = ({ selectedFilters, setSelectedFilters }) => {
  const { t } = useTranslation()
  const handleNavItemClick = (label) => {
    if (label === ALL_BUSINESS_FUNCTIONS) {
      setSelectedFilters({ ...selectedFilters, categories: [] })
    } else {
      const filterKey = Object.keys(categoryType).find((key) => categoryType[key] === label)
      if (filterKey) {
        setSelectedFilters({ ...selectedFilters, categories: [filterKey] })
      }
    }
  }

  return (
    <div className="hidden smd:block sm:w-64 rounded-lg bg-background-appLight p-4 py-7">
      <nav className="flex flex-wrap sm:flex-col sm:gap-y-1 items-center">
        <AppNavItem
          label={ALL_BUSINESS_FUNCTIONS}
          displayLabel={t('goalCenter.allBusinessFunctions')}
          onClick={handleNavItemClick}
          selectedFilters={selectedFilters}
        />
        {Object.values(categoryType).map((categoryLabel) => (
          <AppNavItem
            key={categoryLabel}
            label={categoryLabel}
            displayLabel={t(`goalFlow.categories.${categoryLabel}`, categoryLabel)}
            iconSrc={getIconByCategory(categoryLabel)}
            onClick={handleNavItemClick}
            selectedFilters={selectedFilters}
          />
        ))}
      </nav>
    </div>
  )
}

interface NavItemProps {
  label: string
  displayLabel: string
  iconSrc?: string
  onClick: (label: string) => void
  selectedFilters: { categories: string[] }
}

const AppNavItem: React.FC<NavItemProps> = ({
  label,
  displayLabel,
  iconSrc,
  onClick,
  selectedFilters,
}) => {
  const filterKey = Object.keys(categoryType).find((key) => categoryType[key] === label)
  const isSelected =
    label === ALL_BUSINESS_FUNCTIONS
      ? selectedFilters.categories?.length === 0
      : filterKey
      ? selectedFilters.categories?.includes(filterKey)
      : false

  return (
    <span
      onClick={() => onClick(label)}
      className={`sm:w-full font-inter font-normal leading-5 text-sm p-2
       relative ${
         isSelected
           ? 'bg-background-hover text-black-appDark !font-medium'
           : 'hover:bg-background-hover text-black-appDime'
       } rounded-lg `}
    >
      {displayLabel}
    </span>
  )
}

export default AppSidebar
